/**
 * Roteiro do tutorial: as respostas que as telas reais recebem.
 *
 * GERADO — nao edite a mao. Regenere com scripts/capture_fixtures.py, que grava as
 * respostas de verdade da API sobre a carteira de demonstracao.
 *
 * Gravar em vez de escrever a mao e o que impede o tutorial de ensinar uma tela
 * diferente da real: um roteiro escrito a mao diverge do contrato da API no primeiro
 * campo renomeado, e foi exatamente por isso que o simulado anterior foi apagado.
 *
 * Os dados sao ficticios (carteira semeada), entao nao ha nada de ninguem aqui.
 */

/* eslint-disable */

export const TUTORIAL_CASE_ID = "da14ac21-b191-5a7c-b2d4-eb7792c3be62";

export const TUTORIAL_RENTER_NAME = "Joana Ribeiro Alves";

export const contractsList = {
 "sumarized": [
  {
   "status": "Contrato Ativo",
   "caseStatus": 13,
   "type": "Contrato",
   "caseType": 3,
   "order": 0,
   "total": 2
  },
  {
   "status": "Finalizado - Chaves devolvidas",
   "caseStatus": 181,
   "type": "Contrato",
   "caseType": 3,
   "order": 0,
   "total": 1
  }
 ],
 "count": 1,
 "data": [
  {
   "id": "da14ac21-b191-5a7c-b2d4-eb7792c3be62",
   "brokerId": "c0ffee00-0000-4000-8000-000000000001",
   "client": {
    "id": "50dfabac-f8b7-5485-8af2-ef4f0390aaf3",
    "entityType": null,
    "name": "Joana Ribeiro Alves",
    "fantasyName": null,
    "document": "52998224725",
    "createdById": "80cf665f-5522-454b-94f7-ae73899860eb"
   },
   "broker": {
    "id": "c0ffee00-0000-4000-8000-000000000001",
    "entityType": null,
    "name": "Imobiliaria Modelo",
    "fantasyName": "Imobiliaria Modelo Onboarding",
    "document": "11222333000181",
    "createdById": "00000000-0000-0000-0000-000000000000"
   },
   "value": 0,
   "caseType": 3,
   "status": 13,
   "createdAt": "2026-01-15T19:02:06.498533+00:00",
   "updatedAt": "2026-09-15T19:02:06.498533+00:00",
   "createdBy": {
    "id": "80cf665f-5522-454b-94f7-ae73899860eb",
    "entityType": null,
    "name": "Operador Externo Onboarding",
    "fantasyName": null,
    "document": null,
    "createdById": "00000000-0000-0000-0000-000000000000"
   },
   "quotation": {
    "brokerId": "c0ffee00-0000-4000-8000-000000000001",
    "productId": "094d3ddf-30d7-4fed-9a46-0ee9e9c5231c",
    "brokerProductId": null,
    "propertyId": "2309226d-8392-5a07-8157-a70d2001580e",
    "renterAId": "50dfabac-f8b7-5485-8af2-ef4f0390aaf3",
    "renterBId": null,
    "renterCId": null,
    "renterDId": null,
    "locatorDocument": "11222333000181",
    "locatorName": "Imobiliaria Modelo",
    "ownerContact": {
     "phone": null,
     "phoneType": "Cel",
     "email": null
    },
    "rentValue": 2500.0,
    "rentAdditional": 0.0,
    "rentIptu": 150.0,
    "rentCondominium": 450.0,
    "hasFireInsurance": false,
    "paymentMethod": 1,
    "paymentType": 0,
    "quotationType": 0,
    "status": 13,
    "propertyType": 1,
    "orderValues": {
     "fireInsurance": 0,
     "totalRent": 0,
     "discount": 0,
     "guaranteeValue": 0,
     "guaranteeTotalValue": 0,
     "guaranteeFirstParcel": 0,
     "guaranteeParcel": 0,
     "baseFee": 0,
     "fireInsuranceFee": 0,
     "commission": 0,
     "totalSetup": 0,
     "almadaSetup": 0,
     "brokerSetup": 0,
     "userSetup": 0,
     "commissionValue": 0,
     "totalPaymentValue": 0,
     "value": null,
     "fineValue": null,
     "propertyValue": null,
     "propertyPorpouse": null,
     "propertyState": null,
     "ownResourceFgtsValue": null,
     "ownResourceValue": null,
     "financingValue": null,
     "financingTerms": null,
     "registryFees": false,
     "dueDate": null,
     "indexType": null,
     "indexValue": null,
     "indexReference": null,
     "managementFeePercentage": null,
     "partnerCommissionPercentage": null
    },
    "renterA": {
     "document": "52998224725",
     "name": "Joana Ribeiro Alves",
     "declaredIncomeVerified": 0.0,
     "declaredIncome": 10000.0,
     "birthDate": null,
     "openingDate": null,
     "cnpj": null,
     "fantasyName": null,
     "personType": 1,
     "companyType": null,
     "economicActivityCode": null,
     "occupation": null,
     "socialDocument": null,
     "maritalType": 0,
     "gender": null,
     "nationality": null,
     "birthState": null,
     "birthPlace": null,
     "documentType": null,
     "documentNumber": null,
     "documentIssuer": null,
     "documentIssuerState": null,
     "mothersName": null,
     "documentIssueDate": null,
     "address": {
      "zipCode": 22240003,
      "streetName": "Rua das Laranjeiras",
      "number": "184",
      "additional": null,
      "city": "Rio de Janeiro",
      "district": "Laranjeiras",
      "state": "RJ",
      "lat": null,
      "lng": null,
      "country": "BR",
      "propertyType": null
     },
     "contact": {
      "phone": "11999990000",
      "phoneType": "Cel",
      "email": "joana@exemplo.com.br"
     },
     "score": null,
     "serasaScore": null,
     "serasaScoreUpdatedAt": null,
     "serasaInclusionDate": null,
     "tj": null,
     "scoreUpdatedAt": null,
     "tjUpdatedAt": null,
     "occupationDocument": null,
     "vindiId": null,
     "omieId": null,
     "createdBy": null,
     "deletedBy": null,
     "incomeCompose": false,
     "id": "50dfabac-f8b7-5485-8af2-ef4f0390aaf3",
     "createdAt": "2026-09-15T19:02:05.214863+00:00",
     "updatedAt": null,
     "deletedAt": null,
     "createdById": "80cf665f-5522-454b-94f7-ae73899860eb",
     "deletedById": null,
     "transactionId": null
    },
    "renterB": null,
    "renterC": null,
    "renterD": null,
    "metadata": null,
    "startedAt": null,
    "renewalAt": null,
    "finishedAt": null,
    "fireInsuranceQuotationId": null,
    "fireInsuranceProposalId": null,
    "fireInsurancePolicyId": null,
    "fireInsuranceRenewalId": null,
    "broker": null,
    "product": {
     "name": "Oferta 5",
     "description": null,
     "personType": 1,
     "term": 30,
     "validity": 0,
     "fineDamage": false,
     "fineClient": false,
     "commission": 0.0,
     "fee": {
      "fireInsuranceResidential": 13.0,
      "fireInsuranceCommercial": 24.0,
      "base": 12.8
     },
     "createdBy": null,
     "deletedBy": null,
     "isLegacy": false,
     "rating": "B",
     "maximumExitLimit": 6,
     "sourceProductId": null,
     "sourceProduct": null,
     "id": "094d3ddf-30d7-4fed-9a46-0ee9e9c5231c",
     "createdAt": "2026-09-04T20:29:31+00:00",
     "updatedAt": null,
     "deletedAt": null,
     "createdById": "00000000-0000-0000-0000-000000000000",
     "deletedById": null,
     "transactionId": null
    },
    "property": null,
    "createdBy": null,
    "originatedById": null,
    "originatedBy": null,
    "brokerProduct": null,
    "isDisableCommission": false,
    "isDisableSetup": false,
    "isDisableInvoiced": false,
    "refundedAt": null,
    "id": "af83ab81-3860-55ce-abe2-03c547811122",
    "createdAt": "2026-09-15T19:02:06.086505+00:00",
    "updatedAt": null,
    "deletedAt": null,
    "createdById": "80cf665f-5522-454b-94f7-ae73899860eb",
    "deletedById": null,
    "transactionId": null
   },
   "participants": [
    "Joana Ribeiro Alves",
    "",
    "",
    "",
    "Imobiliaria Modelo",
    "Imobiliaria Modelo Onboarding"
   ],
   "caseRelatedId": null,
   "is": {
    "invoicedSetupBefore": false,
    "portability": null,
    "onePlusZeroPlusEleven": false,
    "processing": false
   },
   "fireInsurancePremium": null,
   "fireInsuranceEndDate": null,
   "fireInsurancePaymentForm": null,
   "policyRating": null,
   "policyPoints": null,
   "occurrenceType": null
  }
 ]
} as const;

export const caseDetail = {
 "data": {
  "workflows": [],
  "_CasesRelated": [],
  "caseRelated": null,
  "actions": {
   "canCancel": false,
   "canAskForRentPendingDocument": true,
   "canRequestCancellation": true,
   "hasOpenCancellationRequest": false,
   "hasCancellationRequest": false
  },
  "occurrenceType": null,
  "quotationId": "af83ab81-3860-55ce-abe2-03c547811122",
  "productId": "094d3ddf-30d7-4fed-9a46-0ee9e9c5231c",
  "brokerId": "c0ffee00-0000-4000-8000-000000000001",
  "status": 13,
  "caseType": 3,
  "cancelledAt": null,
  "cancelledReason": null,
  "reviewCount": 1,
  "caseRelatedId": null,
  "originatedById": null,
  "createdBy": {
   "name": "Operador Externo Onboarding",
   "email": "operador.externo@imobiliariamodelo.com.br",
   "document": null,
   "phone": null,
   "phoneType": "Cel",
   "status": true,
   "brokerId": "c0ffee00-0000-4000-8000-000000000001",
   "lastActivity": "2026-09-15T19:01:50.900027+00:00",
   "lastActivityPasswordRecovery": null,
   "role": "BROKER_USER",
   "setupValue": 0.0,
   "broker": null,
   "receivesCaju": false,
   "userSettings": {},
   "id": "80cf665f-5522-454b-94f7-ae73899860eb",
   "createdAt": "2026-09-15T19:01:50.900027+00:00",
   "updatedAt": null,
   "deletedAt": null,
   "createdById": null,
   "deletedById": null,
   "transactionId": null
  },
  "originatedBy": null,
  "broker": {
   "sheetReferenceId": 9001,
   "name": "Imobiliaria Modelo",
   "fantasyName": "Imobiliaria Modelo Onboarding",
   "document": "11222333000181",
   "creci": null,
   "status": 1,
   "dueDateDay": 10,
   "paymentMethod": 1,
   "address": null,
   "bankAccount": null,
   "commission": 0.0,
   "setupValue": 0.0,
   "almadaSetup": 0.0,
   "brokerEmail": null,
   "financialEmail": null,
   "administrativeEmail": null,
   "phoneType": null,
   "phone": null,
   "managementType": 0,
   "brokerType": 0,
   "vindiId": null,
   "portoSeguroId": null,
   "is": {
    "setupShared": false,
    "paymentAutomationEnabled": false,
    "onePlusZeroPlusEleven": false,
    "disableCommission": false,
    "disableSetup": false,
    "disableInvoiced": false
   },
   "createdBy": null,
   "deletedBy": null,
   "score": null,
   "scoreUpdatedAt": null,
   "responsibleUserId": null,
   "responsibleUser": null,
   "actions": {
    "canChangeInvoiced": true
   },
   "lastPartnerNotificationSentAt": null,
   "id": "c0ffee00-0000-4000-8000-000000000001",
   "createdAt": "2026-09-15T19:02:03.878157+00:00",
   "updatedAt": null,
   "deletedAt": null,
   "createdById": null,
   "deletedById": null,
   "transactionId": null
  },
  "quotation": {
   "brokerId": "c0ffee00-0000-4000-8000-000000000001",
   "productId": "094d3ddf-30d7-4fed-9a46-0ee9e9c5231c",
   "brokerProductId": null,
   "propertyId": "2309226d-8392-5a07-8157-a70d2001580e",
   "renterAId": "50dfabac-f8b7-5485-8af2-ef4f0390aaf3",
   "renterBId": null,
   "renterCId": null,
   "renterDId": null,
   "locatorDocument": "11222333000181",
   "locatorName": "Imobiliaria Modelo",
   "ownerContact": {
    "phone": null,
    "phoneType": "Cel",
    "email": null
   },
   "rentValue": 2500.0,
   "rentAdditional": 0.0,
   "rentIptu": 150.0,
   "rentCondominium": 450.0,
   "hasFireInsurance": false,
   "paymentMethod": 1,
   "paymentType": 0,
   "quotationType": 0,
   "status": 13,
   "propertyType": 1,
   "orderValues": {
    "fireInsurance": 0,
    "totalRent": 0,
    "discount": 0,
    "guaranteeValue": 0,
    "guaranteeTotalValue": 0,
    "guaranteeFirstParcel": 0,
    "guaranteeParcel": 0,
    "baseFee": 0,
    "fireInsuranceFee": 0,
    "commission": 0,
    "totalSetup": 0,
    "almadaSetup": 0,
    "brokerSetup": 0,
    "userSetup": 0,
    "commissionValue": 0,
    "totalPaymentValue": 0,
    "value": null,
    "fineValue": null,
    "propertyValue": null,
    "propertyPorpouse": null,
    "propertyState": null,
    "ownResourceFgtsValue": null,
    "ownResourceValue": null,
    "financingValue": null,
    "financingTerms": null,
    "registryFees": false,
    "dueDate": null,
    "indexType": null,
    "indexValue": null,
    "indexReference": null,
    "managementFeePercentage": null,
    "partnerCommissionPercentage": null
   },
   "renterA": {
    "document": "52998224725",
    "name": "Joana Ribeiro Alves",
    "declaredIncomeVerified": 0.0,
    "declaredIncome": 10000.0,
    "birthDate": null,
    "openingDate": null,
    "cnpj": null,
    "fantasyName": null,
    "personType": 1,
    "companyType": null,
    "economicActivityCode": null,
    "occupation": null,
    "socialDocument": null,
    "maritalType": 0,
    "gender": null,
    "nationality": null,
    "birthState": null,
    "birthPlace": null,
    "documentType": null,
    "documentNumber": null,
    "documentIssuer": null,
    "documentIssuerState": null,
    "mothersName": null,
    "documentIssueDate": null,
    "address": {
     "zipCode": 22240003,
     "streetName": "Rua das Laranjeiras",
     "number": "184",
     "additional": null,
     "city": "Rio de Janeiro",
     "district": "Laranjeiras",
     "state": "RJ",
     "lat": null,
     "lng": null,
     "country": "BR",
     "propertyType": null
    },
    "contact": {
     "phone": "11999990000",
     "phoneType": "Cel",
     "email": "joana@exemplo.com.br"
    },
    "score": null,
    "serasaScore": null,
    "serasaScoreUpdatedAt": null,
    "serasaInclusionDate": null,
    "tj": null,
    "scoreUpdatedAt": null,
    "tjUpdatedAt": null,
    "occupationDocument": null,
    "vindiId": null,
    "omieId": null,
    "createdBy": null,
    "deletedBy": null,
    "incomeCompose": false,
    "id": "50dfabac-f8b7-5485-8af2-ef4f0390aaf3",
    "createdAt": "2026-09-15T19:02:05.214863+00:00",
    "updatedAt": null,
    "deletedAt": null,
    "createdById": "80cf665f-5522-454b-94f7-ae73899860eb",
    "deletedById": null,
    "transactionId": null
   },
   "renterB": null,
   "renterC": null,
   "renterD": null,
   "metadata": null,
   "startedAt": null,
   "renewalAt": null,
   "finishedAt": null,
   "fireInsuranceQuotationId": null,
   "fireInsuranceProposalId": null,
   "fireInsurancePolicyId": null,
   "fireInsuranceRenewalId": null,
   "broker": null,
   "product": {
    "name": "Oferta 5",
    "description": null,
    "personType": 1,
    "term": 30,
    "validity": 0,
    "fineDamage": false,
    "fineClient": false,
    "commission": 0.0,
    "fee": {
     "fireInsuranceResidential": 13.0,
     "fireInsuranceCommercial": 24.0,
     "base": 12.8
    },
    "createdBy": null,
    "deletedBy": null,
    "isLegacy": false,
    "rating": "B",
    "maximumExitLimit": 6,
    "sourceProductId": null,
    "sourceProduct": null,
    "id": "094d3ddf-30d7-4fed-9a46-0ee9e9c5231c",
    "createdAt": "2026-09-04T20:29:31+00:00",
    "updatedAt": null,
    "deletedAt": null,
    "createdById": "00000000-0000-0000-0000-000000000000",
    "deletedById": null,
    "transactionId": null
   },
   "property": {
    "brokerId": "c0ffee00-0000-4000-8000-000000000001",
    "propertyType": 1,
    "address": {
     "zipCode": 22240003,
     "streetName": "Rua das Laranjeiras",
     "number": "184",
     "additional": null,
     "city": "Rio de Janeiro",
     "district": "Laranjeiras",
     "state": "RJ",
     "lat": null,
     "lng": null,
     "country": "BR",
     "propertyType": 1
    },
    "broker": null,
    "createdBy": null,
    "deletedBy": null,
    "propertyKind": null,
    "id": "2309226d-8392-5a07-8157-a70d2001580e",
    "createdAt": "2026-09-15T19:02:05.650229+00:00",
    "updatedAt": null,
    "deletedAt": null,
    "createdById": "80cf665f-5522-454b-94f7-ae73899860eb",
    "deletedById": null,
    "transactionId": null
   },
   "createdBy": {
    "name": "Operador Externo Onboarding",
    "email": "operador.externo@imobiliariamodelo.com.br",
    "document": null,
    "phone": null,
    "phoneType": "Cel",
    "status": true,
    "brokerId": "c0ffee00-0000-4000-8000-000000000001",
    "lastActivity": "2026-09-15T19:01:50.900027+00:00",
    "lastActivityPasswordRecovery": null,
    "role": "BROKER_USER",
    "setupValue": 0.0,
    "broker": null,
    "receivesCaju": false,
    "userSettings": {},
    "id": "80cf665f-5522-454b-94f7-ae73899860eb",
    "createdAt": "2026-09-15T19:01:50.900027+00:00",
    "updatedAt": null,
    "deletedAt": null,
    "createdById": null,
    "deletedById": null,
    "transactionId": null
   },
   "originatedById": null,
   "originatedBy": null,
   "brokerProduct": null,
   "isDisableCommission": false,
   "isDisableSetup": false,
   "isDisableInvoiced": false,
   "refundedAt": null,
   "id": "af83ab81-3860-55ce-abe2-03c547811122",
   "createdAt": "2026-09-15T19:02:06.086505+00:00",
   "updatedAt": null,
   "deletedAt": null,
   "createdById": "80cf665f-5522-454b-94f7-ae73899860eb",
   "deletedById": null,
   "transactionId": null
  },
  "product": null,
  "casesRelated": [],
  "contractStartedAt": "2026-01-15T19:02:06.498533+00:00",
  "contractFinishedAt": "2028-07-15T19:02:06.498533+00:00",
  "is": {
   "invoicedSetupBefore": false,
   "portability": null,
   "onePlusZeroPlusEleven": false,
   "processing": false
  },
  "managedBy": 0,
  "managers": [],
  "id": "da14ac21-b191-5a7c-b2d4-eb7792c3be62",
  "createdAt": "2026-01-15T19:02:06.498533+00:00",
  "updatedAt": "2026-09-15T19:02:06.498533+00:00",
  "deletedAt": null,
  "createdById": "80cf665f-5522-454b-94f7-ae73899860eb",
  "deletedById": null,
  "transactionId": null
 }
} as const;

export const occurrenceLimits = {
 "data": {
  "productName": "Oferta 5",
  "maxGeneralLimit": 75000.0,
  "maxExitLimit": 15000.0,
  "usedGeneralAmount": 0,
  "usedExitAmount": 0,
  "currentRent": 2500.0,
  "availableGeneralAmount": 75000.0,
  "availableExitAmount": 15000.0,
  "isFirstOccurrence": true
 }
} as const;

export const collectionResume = {
 "data": {
  "allAgreementsPendingValue": 0,
  "allAgreementsPaidValue": 0,
  "allDealsValue": 0,
  "allCollectionsTotalValue": 0,
  "allCollectionsLegalFeesValue": 0.0,
  "pendingCollectionsTotal": 0,
  "pendingCollectionsBase": 0,
  "pendingCollectionsLegalFees": 0.0,
  "pendingCollectionsTotalWithFees": 0.0,
  "relatedCases": [],
  "paidCollections": [],
  "pendingCollections": [],
  "updatedDebt": 0
 }
} as const;

export const statusTrackLogs = {
 "data": []
} as const;

export const documentTypes = {
 "data": [
  {
   "value": 14,
   "label": "Apólice Seguro Incêndio",
   "order": 0
  },
  {
   "value": 22,
   "label": "Boleto",
   "order": 0
  },
  {
   "value": 12,
   "label": "Carta de Aprovação",
   "order": 0
  },
  {
   "value": 8,
   "label": "Comprovante de Análise de Score",
   "order": 0
  },
  {
   "value": 26,
   "label": "Comprovante de pagamento",
   "order": 0
  },
  {
   "value": 11,
   "label": "Comprovante INSS",
   "order": 0
  },
  {
   "value": 23,
   "label": "Conta de consumo (Agua, gás e etc..)",
   "order": 0
  },
  {
   "value": 1,
   "label": "Contrato de locação",
   "order": 0
  },
  {
   "value": 0,
   "label": "Contrato social",
   "order": 0
  },
  {
   "value": 7,
   "label": "Documento de Identidade (RG, CNH ou Carteira Profissional)",
   "order": 0
  },
  {
   "value": 5,
   "label": "Documento de Renda",
   "order": 0
  },
  {
   "value": 10,
   "label": "Extrato Bancário - 3 meses",
   "order": 0
  },
  {
   "value": 6,
   "label": "Fatura do Cartão de Crédito",
   "order": 0
  },
  {
   "value": 9,
   "label": "Holerite - 3 meses",
   "order": 0
  },
  {
   "value": 28,
   "label": "Imagem",
   "order": 0
  },
  {
   "value": 3,
   "label": "Imposto de Renda - Recibo",
   "order": 0
  },
  {
   "value": 4,
   "label": "Imposto de Renda Pessoa Fisica",
   "order": 0
  },
  {
   "value": 29,
   "label": "Notificação de exoneração",
   "order": 0
  },
  {
   "value": 30,
   "label": "Notificação de exoneração do fiador",
   "order": 0
  },
  {
   "value": 27,
   "label": "Notificação extrajudicial",
   "order": 0
  },
  {
   "value": 32,
   "label": "Notificação extrajudicial de cobrança",
   "order": 0
  },
  {
   "value": 24,
   "label": "Orçamento",
   "order": 0
  },
  {
   "value": 15,
   "label": "Proposta Seguro Incêndio",
   "order": 0
  },
  {
   "value": 21,
   "label": "Termo Aditivo da Carta Fiança",
   "order": 0
  },
  {
   "value": 17,
   "label": "Termo Aditivo de Contrato de Locação",
   "order": 0
  },
  {
   "value": 25,
   "label": "Termo de confissão de dívida",
   "order": 0
  },
  {
   "value": 31,
   "label": "Termo de confissão de dívida - Assinado",
   "order": 0
  },
  {
   "value": 19,
   "label": "Termo de Entrega de Chaves",
   "order": 0
  },
  {
   "value": 33,
   "label": "Termo de quitação de dívida",
   "order": 0
  },
  {
   "value": 13,
   "label": "Termos e Condições",
   "order": 0
  },
  {
   "value": 18,
   "label": "Termos e Condições - Assinado",
   "order": 0
  },
  {
   "value": 16,
   "label": "Termos e condições gerais",
   "order": 0
  },
  {
   "value": 2,
   "label": "Vistoria de entrada",
   "order": 0
  },
  {
   "value": 20,
   "label": "Vistoria de Saída",
   "order": 0
  }
 ]
} as const;
